import React from 'react';

export default function useSEO(options, canonical = null) {
    const { title = null, description = null, noIndex = false} = options;

    const removeCanonicalElement = () => {
        const elements = document.querySelectorAll('link[rel="canonical"]');
        elements.forEach(element => {
            element.remove();
        });
    }

    React.useEffect(() => {
        let prevTitle = null;
        if (title) {
            prevTitle = document.title
            document.title = title
        }

         if (description) {
             const div = document.createElement('div');
             div.innerHTML = description;
             const descriptionNoHTML = div.textContent || div.innerText || '';
             document.querySelector('meta[name="description"]').setAttribute('content', descriptionNoHTML);
        }

        const robotElement = document.querySelector('meta[name="robots"]');
        const googlebotElement = document.querySelector('meta[name="googlebot"]');

        if (noIndex) {
            googlebotElement.setAttribute('content', "noindex");
            robotElement.setAttribute('content', "noindex");
        } else {
            robotElement.setAttribute('content', "");
            googlebotElement.setAttribute('content', "");
        }

        return () => {
            if (prevTitle && prevTitle !== 'null') {
                document.title = prevTitle
            }
        }
    }, []);

    React.useEffect(() => {
        console.log('update canonical', canonical);
        if (!canonical) {
            removeCanonicalElement();
        }

        if (canonical && canonical !== window.location.pathname) {
            removeCanonicalElement();

            const canonicalElement = document.createElement('link');
            canonicalElement.setAttribute('href', window.location.origin + canonical);
            canonicalElement.setAttribute('rel', 'canonical');
            document.querySelector('head').append(canonicalElement);
        }
    }, [canonical]);
}